<template>
  <div>
    <fund-selector @fund-selected="onFundSelected($event)" />
    <data-source-conflicts
      v-if="selectedFund"
      ref="DataSourceConflicts"
      :fund="selectedFund"
    />
  </div>
</template>

<script>
import DataSourceConflicts from '../components/FundReporting/DataSourceConflicts.vue'
import FundSelector from '../components/FundReporting/FundSelector.vue'

export default {
  components: {
    DataSourceConflicts,
    FundSelector,
  },
  data() {
    return {
      selectedFund: null,
    }
  },
  methods: {
    onFundSelected(payload) {
      this.selectedFund = payload.fund
    },
  },
}
</script>

<style></style>
